import state from '@/store'
import { execute } from '@/services/websocket/actionsToMessages'

let ws: WebSocket | undefined

const connectWs = () => {
  const token = state.wsToken
  if (!token) {
    // TODO: Implement modal error
    alert('Error! Please, update page!')
    return
  }

  const url = process.env.VUE_APP_WS_PATH
  const urlWs = process.env.VUE_APP_WS_URL // TODO: Replace to reseller URL

  if (!url || !urlWs) {
    console.error('[CHAT] ENVIROMENT VARIABLE IS NOT DEFINED')
    return
  }

  // Check if websocket is already connected
  if (ws?.readyState === WebSocket.OPEN) return ws

  console.log('Connected?', ws?.readyState === WebSocket.OPEN)

  ws = new WebSocket(`${urlWs}/${url}?token=${token}`)

  // TODO: Fetch messages only when connecting to websocket???
  ws.onopen = () => console.log('[CHAT] Connection established')
  ws.onmessage = (event) => wsOnMessage(event)
  ws.onerror = () => ws?.close()
  ws.onclose = () => wsOnClose()
}

/**
 * Handle websocket messages
 * @param {MessageEvent} event
 */
const wsOnMessage = (event: MessageEvent) => {
  const data = JSON.parse(event.data)
  const execAction = data?.action || data?.type || data?.event || undefined
  if (!execAction || typeof execAction === undefined) return

  const execData = data?.data || data?.payload || undefined
  if (!execAction || typeof execData === undefined) return

  const channel = data?.channel || undefined
  if (!channel || typeof channel === undefined) return

  execute(channel, execAction, execData)
}

/**
 * Send message to websocket
 * @param {string} channel
 * @param {string} type
 * @param {object} message
 * @param {number[]} toUsers
 */
const sendMessage = (channel: string, type: string, message: object, toUsers: number[]) => {
  if (!ws || ws.readyState !== WebSocket.OPEN) {
    console.error('[CHAT] Connection is not established')
    return
  }

  const payload = {
    channel,
    type,
    data: message,
    to_users: toUsers
  }

  ws?.send(JSON.stringify(payload))
}

/**
 * @param {string} type
 * @param {object} message
 * @param {number[]} toUsers
 */
const sendMessageWebchat = (type: string, message: object, toUsers: number[]) => {
  sendMessage('webchat', type, message, toUsers)
}

/**
 * Handle websocket close with automatically reconnects
 */
const wsOnClose = () => {
  // TODO: Implement modal error

  console.error('[CHAT] Connection closed. Reconnecting...')
  setTimeout(() => connectWs(), 1000)
}

export default {
  connectWs,
  sendMessage,
  sendMessageWebchat
}
